export const SECTION_MIRROR = '@/SECTION_MIRROR';
export const SELECT_COLORS_LIST = [
  '#ffffff',
  '#000000',
  '#0298a1',
  '#017980',
  '#d8134e',
  '#95be0e',
  '#aec8d2',
];